import React, { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { Link } from 'react-router-dom';
import { FaWallet, FaRupeeSign, FaPlus, FaArrowUp } from 'react-icons/fa';
import axios from 'axios';
import toast from 'react-hot-toast';
import { Helmet } from 'react-helmet-async';

const Wallet = () => {
  const [wallet, setWallet] = useState(null);
  const [loading, setLoading] = useState(true);
  const { token } = useSelector((state) => state.auth);

  useEffect(() => {
    fetchWalletData();
  }, []);

  const fetchWalletData = async () => {
    try {
      const walletRes = await axios.get(`${process.env.REACT_APP_API_URL || 'http://localhost:5000/api'}/wallet`, {
        headers: { Authorization: `Bearer ${token}` }
      });
      setWallet(walletRes.data.wallet);
    } catch (error) {
      console.error('Error fetching wallet:', error);
    } finally {
      setLoading(false);
    }
  };



  if (loading) {
    return (
      <div className="flex justify-center items-center h-96">
        <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-green-600"></div>
      </div>
    );
  }

  return (
    <>
      <Helmet>
        <title>My Wallet - Assets Dairy Farm</title>
      </Helmet>

      <div className="bg-gray-50 min-h-screen py-8">
        <div className="container mx-auto px-4">
          {/* Header */}
          <div className="mb-8">
            <h1 className="text-3xl font-bold text-gray-800">My Wallet</h1>
            <p className="text-gray-600 mt-1">Manage your funds and transactions</p>
          </div>

          {/* Balance Card */}
          <div className="bg-gradient-to-r from-green-500 to-green-700 rounded-2xl shadow-xl p-8 mb-8 text-white">
            <div className="flex justify-between items-start">
              <div>
                <p className="text-sm opacity-90">Available Balance</p>
                <p className="text-4xl font-bold mt-2">₹{wallet?.balance?.toLocaleString() || 0}</p>
                <p className="text-xs opacity-80 mt-2">Total Credited: ₹{wallet?.totalCredited?.toLocaleString() || 0}</p>
              </div>
              <div className="bg-white/20 rounded-full p-4">
                <FaWallet className="text-3xl" />
              </div>
            </div>
            <div className="mt-6 flex justify-center">
              <Link to="/investor/withdraw" className="w-full sm:w-auto px-8 bg-white text-green-600 py-3 rounded-lg font-bold hover:bg-gray-100 transition flex items-center justify-center gap-2 shadow-md">
                <FaArrowUp /> Withdraw Profit
              </Link>
            </div>
          </div>

          {/* Note */}
          <div className="bg-yellow-50 rounded-lg p-4 text-sm text-yellow-800 text-center border border-yellow-200">
            💡 Profit automatically transfers to your wallet on the 1st of every month. You can withdraw your balance anytime.
          </div>
        </div>
      </div>
    </>
  );
};

export default Wallet;